/**
 * require.context(directory, useSubdirectories, regExp)
 * directory：表示检索的目录
 * useSubdirectories：表示是否检索子文件夹
 * regExp：匹配文件的正则表达式，一般是文件名
 */ 

const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('./modules/', true, /\.js$/)
let apis = {}
requireAll(req).forEach(item => {
  apis = {...apis, ...item}
})

export default apis
